import { render, staticRenderFns } from "./ValorUnitario.vue?vue&type=template&id=8633afca"
import script from "./ValorUnitario.vue?vue&type=script&lang=js"
export * from "./ValorUnitario.vue?vue&type=script&lang=js"
import style0 from "./ValorUnitario.vue?vue&type=style&index=0&id=8633afca&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports